import { useReducer } from 'react';
import { OffsiteCampaignsListReducer } from './OffsiteCampaignsListReducer';
import {
  defaultContextValues,
  IAction,
  IState,
  OffsiteCampaignsListDispatchContext,
  OffsiteCampaignsListStateContext,
} from './UseOffsiteCampaignsListContext';

export interface IValue {
  initialState: IState;
  reducer: (state: IState, action: IAction) => IState;
}

interface ICampaignsListProviderProps {
  children: any;
  value?: IValue;
}

export function OffsiteCampaignsListProvider({
  children,
  value = { initialState: defaultContextValues, reducer: OffsiteCampaignsListReducer },
}: ICampaignsListProviderProps) {
  const [state, dispatch] = useReducer(value.reducer, value.initialState);

  return (
    <OffsiteCampaignsListStateContext.Provider value={state}>
      <OffsiteCampaignsListDispatchContext.Provider value={dispatch}>
        {children}
      </OffsiteCampaignsListDispatchContext.Provider>
    </OffsiteCampaignsListStateContext.Provider>
  );
}
